import {useMutation} from '@tanstack/react-query';
import TournamentRestClient from '@/Api/TournamentRestClient';
import {formatPlayerDisplay} from '@/Utils/CommonUtils';

export default function useGetPlayerDetails(
  handleOnSuccess?: (data: any) => void,
  handleOnError?: (error: any) => void,
) {
  const mutation = useMutation(
    async ({uuid, tournamentId}: {uuid: string; tournamentId: string}) => {
      const response = await TournamentRestClient.get(
        `/players/details?uuid=${uuid}&tournamentId=${tournamentId}`,
      );
      if (response?.data?.data) {
        if (response?.data?.data?.details) {
          response.data.data.details = formatPlayerDisplay(
            response?.data?.data?.details,
          );
        }
        if (Array.isArray(response?.data?.data?.opponents)) {
          response.data.data.opponents =
            response?.data?.data?.opponents.map(formatPlayerDisplay);
        }
      }
      console.log(response?.data, 'useGetPlayerDetails response');

      return response?.data;
    },
    {
      onSuccess: data => {
        if (handleOnSuccess) handleOnSuccess(data);
      },
      onError: error => {
        if (handleOnError) handleOnError(error);
      },
    },
  );

  return mutation;
}
